export const dialog = {
  root: {
    background: "{overlay.modal.background}",
    borderColor: "{overlay.modal.border.color}",
    color: "{overlay.modal.color}",
    borderRadius: "{overlay.modal.border.radius}",
    shadow: "{overlay.modal.shadow}",
  },
  header: {
    padding: "{overlay.modal.padding}",
    gap: "0.5rem",
  },
  title: {
    fontSize: "{typography.card.heading.font.size}",
    fontWeight: "{typography.card.heading.font.weight}",
  },
  content: {
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}",
  },
  footer: {
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}",
    gap: "0.5rem",
  },
  colorScheme: {
    light: {
      root: {
        background: "{overlay.modal.background}",
      },
    },
    dark: {
      root: {
        background: "{overlay.modal.background}",
      },
    },
  },
  css: (): string => `
    .p-dialog {
      max-width: 90%;
    }

    .p-dialog-content:empty {
      display: none;
    }

    .signing-form-dialog .p-dialog-content {
      display: flex;
    }
  `,
};
